import { Button, getCSSVar } from "@tosize/ui";
import { FormattedMessage } from "react-intl";
import { AppModus } from "../../../../hooks/useCanvasStore";
import { useNavigation } from "../../../../hooks/useNavigation";
import { Divider } from "../../Divider";
import Dimensions from "./../../../form/Dimensions";
import Material from "./../../../form/Material";
import Thickness from "./../../../form/Thickness";

export default function FormContent() {
	const { navigate } = useNavigation();

	return (
		<div className="space-y-3">
			<Dimensions />
			<Divider />
			<Material />
			<Divider />
			<Thickness />

			<div className="flex items-center justify-center">
				<Button
					color="success"
					onClick={() => {
						const element = document.querySelector("#start-ordering");
						const top = (element?.getBoundingClientRect().top ?? 0) + window.scrollY;
						const headerHeight = getCSSVar("--header-y");

						window.scrollTo({ top: top - headerHeight, behavior: "smooth" });

						return navigate(AppModus.layout);
					}}
				>
					<FormattedMessage defaultMessage="Doorgaan naar indeling aanpassen" id="Klozmr" />
				</Button>
			</div>
		</div>
	);
}
